export enum GridFlavorEnum {
    RegularGrid = 'regularGrid',
    AttachmentsGrid = 'attachmentsGrid',
    ContactsGrid = 'contactsGrid'
}

export enum GridEventTypeEnum {
    Download = 'download',
    Upload = 'upload',
    Delete = 'delete',
    Restore = 'restore'
}

export enum AttachmentStandardColumnNames{
    Title = 'standard_attachment_title_column',
    FileName = 'standard_attachment_file_name_column',
    FileType = 'standard_attachment_file_type_column',
    UploadInfo = 'standard_attachment_upload_info_column',
    DownloadInfo = 'standard_attachment_download_info_column',
    Version = 'standard_attachment_version_column',
    IsLatest = 'standard_attachment_is_latest_version_column',
    IsDisabled = 'standard_attachment_is_disabled_column'
}

export enum AttachmentStandardColumnIndicators{
    Title = 1,
    FileName = 2,
    FileType = 3,
    UploadInfo = 4,
    DownloadInfo = 5,
    Version = 6,
    IsLatest = 7,
    IsDisabled = 8
}

export enum GridFlavorModifiersEnum {
    ShowAll = 'ShowAll',
    ShowLatestOnly = 'ShowLatestOnly'
}
